import React, { useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { ImageOption, ImagePickerDialog } from './ImagePickerDialog';

export type ImagePickerProps = {
  name: string; // name of the hidden input
  images: ImageOption[];
  initialImage?: ImageOption;
};

const ImagePicker: React.FC<ImagePickerProps> = (
  {
    name,
    images,
    initialImage
  }) => {
  const [selectedImage, setSelectedImage] = useState<ImageOption | null>(initialImage);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const changeButtonRef = useRef<HTMLButtonElement>(null);


  const handleSelect = (image: ImageOption | null) => {
    setSelectedImage(image);
  };

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => {
    requestAnimationFrame(() => changeButtonRef.current?.focus());
    return setIsDialogOpen(false);
  };

  return (
    <>
      <input type="hidden" name={name} value={selectedImage?.key ?? ''}/>

      {selectedImage && selectedImage.key ? (
        <div className="position-relative d-inline-block">
          <img
            src={selectedImage.src}
            alt={selectedImage.filename}
            onClick={openDialog}
          />
          <small className="d-block text-center text-muted mt-1 text-truncate">
            {selectedImage.filename}
          </small>
        </div>
      ) : (
        <button
          ref={changeButtonRef}
          type="button"
          className="btn btn-outline-primary"
          onClick={openDialog}>
          Select image
        </button>
      )}

      {isDialogOpen && (
        <>
          <ImagePickerDialog
            images={images}
            selectedImage={selectedImage}
            onSelect={handleSelect}
            onClose={closeDialog}
          />
        </>
      )}
    </>
  );
};


export default function registerImagePicker(options: {
  container: HTMLElement,
  name: string,
  initialImage?: ImageOption,
  images?: ImageOption[]
}) {
  if (options.container) {
    createRoot(options.container).render(
      <ImagePicker
        name={options.name}
        images={options.images}
        initialImage={options.initialImage}
      />
    );
  }
}
